import { BlackCheckBox } from "../../atoms/RTCC/blackCheckBox";
import { Label } from "../../atoms/RTCC/label";
import './../../../resources/RTCC/css/reservation/reservation.css';

export const CheckboxListBox = (props) => {
    const { labelAreaStyle, title, data, onChange, name } = props;
    return (
        <div className="divStyle">
            <Label style={labelAreaStyle} label={title} />
            {data ? data.map((d, index) => (
                <BlackCheckBox
                    key={name + index}
                    name={name}
                    onChange={onChange}
                    label={d.label}
                    value={d.value}
                    defaultChecked={d.checked} />
            )) : null}
        </div>
    );
};